<template lang="pug">
  li.match(:class="{ 'isGeneral': card.isGeneral }")
    .match-header(@click="goToMatchTop")
      .result-badge(v-if="card.phase === 'result'") 最終結果発表!!
      .date(v-else-if="card.phase === 'beforeStart'") {{ card.startDateTime | formatDate }}から開催します
      .date(v-else-if="card.phase === 'inProgress'") {{ card.startDateTime | formatDate }}〜{{ card.displayEndDateTime | formatDate }}
      .date(v-else-if="card.phase === 'calculating'") 現在集計中
      .title-row
        .title {{ card.name }}
      .debug-phase-switch(v-if="isDevelopment" @click.stop)
        button(type="button" @click="$emit('set-debug-phase', card.id, 'beforeStart')") 開催前
        button(type="button" @click="$emit('set-debug-phase', card.id, 'inProgress')") 期間中
        button(type="button" @click="$emit('set-debug-phase', card.id, 'calculating')") 集計中
        button(type="button" @click="$emit('set-debug-phase', card.id, 'result')") 最終結果
    .match-body
      .image(v-if="card.cardImageUrl" @click="goToMatchTop")
        img(:src="card.cardImageUrl" :alt="card.name")
      .entry(v-if="card.bodyType === 'entry'")
        template(v-if="card.hasFaction")
          p.faction-guide 選んでエントリーしよう
          .faction-select
            .faction-row(v-for="faction in card.factions" :key="faction.id")
              button.faction-button(
                type="button"
                :disabled="processing"
                :style="factionOutlineStyle(faction)"
                @click="requestEnterWithFaction(faction)"
              ) {{ faction.name }}
              .faction-count
                img.user-icon(src="@/assets/images/icon_user.svg" alt="")
                span {{ formatFactionCount(faction) }}
        template(v-else)
          button.entry-button(type="button" :disabled="processing" @click="requestEnter") エントリー
      .entry(v-else-if="card.bodyType === 'entered'")
        template(v-if="card.hasFaction")
          p.faction-guide エントリー済です。開始をお楽しみに！
          .faction-select
            .faction-row(v-for="faction in card.factions" :key="faction.id")
              button.faction-button(
                type="button"
                disabled
                :class="{ selected: faction.id === card.factionID }"
                :style="factionSelectedStyle(faction, faction.id === card.factionID)"
              )
                img.check-icon(v-if="faction.id === card.factionID" src="@/assets/images/icon_check.svg" alt="")
                span {{ faction.name }}
              .faction-count
                img.user-icon(src="@/assets/images/icon_user.svg" alt="")
                span {{ formatFactionCount(faction) }}
        template(v-else)
          button.entry-button.entered エントリー済み
          p.wait-message 開催までお待ちください
        .cancel
          button.cancel-button(type="button" :disabled="processing" @click="requestCancel") キャンセルする
      .faction-progress(v-else-if="card.bodyType === 'stats' && card.hasFaction")
        .faction-stat(
          v-for="faction in card.factions"
          :key="faction.id"
          :class="{ isMine: faction.id === card.factionID }"
        )
          .faction-meta
            .name(:style="{ color: faction.lightTextColor }") {{ faction.name }}派
            .faction-count
              img.user-icon(src="@/assets/images/icon_user.svg" alt="")
              span {{ formatFactionCount(faction) }}
          .mine-badge(v-if="faction.id === card.factionID" :style="mineBadgeStyle(faction)") あなたのなかま
          .bar-wrap
            .bar-track(:style="{ backgroundColor: faction.lightBgColor }")
              .bar-fill(
                :style="{ width: getFactionBarWidth(card.factions, faction) + '%', backgroundColor: faction.darkBgColor }"
              )
              .bar-steps(:style="factionBarStepsStyle(faction)") {{ formatFactionSteps(faction) }} 歩
            .win-badge(v-if="card.phase === 'result' && faction.rank === 1")
              span.crown(aria-hidden="true")
                svg(viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg")
                  path(d="M2 12h12l-1.2-6.5L9.5 8.5 8 3.5 6.5 8.5 3.2 5.5 2 12z" fill="#c49200")
                  rect(x="2" y="12" width="12" height="1.5" rx="0.5" fill="#c49200")
              span 勝ち！
        .stats
          .stat
            .label 全体順位
            .value {{ card.rankText }} 位
          .stat
            .label 平均歩数
            .value {{ card.stepsText }} 歩
        .company-rank(@click="goToMatchRanking") 社内順位をチェック！
      .stats(v-else-if="card.bodyType === 'stats'")
        .stat
          .label 順位
          .value {{ card.rankText }} 位
        .stat
          .label 平均歩数
          .value {{ card.stepsText }} 歩
      .calculating(v-else-if="card.bodyType === 'calculating'")
        .label 最終結果発表予定日
        .value {{ card.calculationEndDateTime | formatDate }}
    IndividualMatchEntryQuestions(
      v-if="showQuestionnaire"
      ref="questions"
      :questions="card.questions"
      @submit="onQuestionsAnswered"
    )
</template>
<script>
import IndividualMatchEntryQuestions from '@/components/Home/IndividualMatchEntryQuestions'

export default {
  components: {
    IndividualMatchEntryQuestions,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
    isDevelopment: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showQuestionnaire: false,
      pendingFactionId: null,
      processing: false,
    }
  },
  methods: {
    goToMatchTop() {
      this.$router.push({
        name: 'individualMatch',
        params: { id: this.card.id },
        query: { isGeneral: String(this.card.isGeneral) },
      })
    },
    goToMatchRanking() {
      this.$router.push({
        name: 'individualMatchRanking',
        params: { id: this.card.id },
        query: { isGeneral: String(this.card.isGeneral) },
      })
    },
    async requestEnter() {
      if (this.processing) {
        return
      }
      this.pendingFactionId = null
      if (this.card.hasQuestions) {
        this.openQuestionnaire()
        return
      }
      const confirmed = await this.confirmDialog({
        title: 'エントリーしますか？',
      })
      if (!confirmed) {
        return
      }
      await this.enterIndividualMatch()
    },
    async requestEnterWithFaction(faction) {
      if (this.processing) {
        return
      }
      this.pendingFactionId = faction.id
      if (this.card.hasQuestions) {
        this.openQuestionnaire()
        return
      }
      const confirmed = await this.confirmDialog({
        title: 'エントリーしますか？',
      })
      if (!confirmed) {
        this.pendingFactionId = null
        return
      }
      await this.enterIndividualMatch()
    },
    openQuestionnaire() {
      this.showQuestionnaire = true
      this.$nextTick(() => {
        if (this.$refs.questions) {
          this.$refs.questions.open(this.card.id)
        }
      })
    },
    async onQuestionsAnswered(matchId, answers) {
      this.showQuestionnaire = false
      if (matchId !== this.card.id) {
        this.pendingFactionId = null
        return
      }
      await this.enterIndividualMatch(answers)
    },
    async requestCancel() {
      if (this.processing) {
        return
      }
      const confirmed = await this.confirmDialog({
        title: 'エントリーをキャンセルしますか？',
      })
      if (!confirmed) {
        return
      }
      await this.cancelIndividualMatchEntry()
    },
    async enterIndividualMatch(body) {
      if (this.processing) {
        return
      }
      this.processing = true
      const factionId = this.pendingFactionId
      try {
        const params = {
          individualMatchID: this.card.id,
          isGeneral: this.card.isGeneral,
        }
        if (body) {
          params.body = body
        }
        if (this.card.hasFaction && factionId) {
          params.factionID = factionId
        }
        await this.serverCode('enterIndividualMatch', params)
        this.$emit('updated')
      } finally {
        this.processing = false
        this.pendingFactionId = null
      }
    },
    async cancelIndividualMatchEntry() {
      if (this.processing) {
        return
      }
      this.processing = true
      try {
        await this.serverCode('cancelIndividualMatchEntry', {
          individualMatchID: this.card.id,
          isGeneral: this.card.isGeneral,
        })
        this.$emit('updated')
      } finally {
        this.processing = false
      }
    },
    factionOutlineStyle(faction) {
      return {
        borderColor: faction.lightBgColor,
        color: faction.lightTextColor || faction.lightBgColor,
      }
    },
    factionSelectedStyle(faction, selected) {
      if (!selected) {
        return this.factionOutlineStyle(faction)
      }
      return {
        borderColor: faction.lightBgColor,
        backgroundColor: faction.lightBgColor,
        color: '#fff',
      }
    },
    mineBadgeStyle(faction) {
      return {
        backgroundColor: faction.lightBgColor,
        color: faction.lightTextColor || '#fff',
      }
    },
    factionBarStepsStyle(faction) {
      if (faction.averageSteps == null) {
        return {
          color: faction.lightTextColor || '#333',
          textShadow: 'none',
        }
      }
      return {
        color: '#fff',
      }
    },
    getFactionBarWidth(factions, faction) {
      const maxSteps = Math.max(
        ...factions.map(item => item.averageSteps || 0),
        0
      )
      if (maxSteps <= 0 || faction.averageSteps == null) {
        return 0
      }
      return Math.round((faction.averageSteps / maxSteps) * 100)
    },
    formatFactionCount(faction) {
      if (faction.count == null) {
        return '-人'
      }
      return `${this.formatNumber(faction.count)}人`
    },
    formatFactionSteps(faction) {
      if (faction.averageSteps == null) {
        return '-'
      }
      return this.formatNumber(faction.averageSteps)
    },
    formatNumber(value) {
      return Number(value).toLocaleString()
    },
  },
}
</script>
<style scoped lang="scss">
.match {
  border: 1px solid #c0f; // テナント主催の色
  border-radius: 8px;
  background: #fff;
  margin-bottom: 12px;
}

.match-header {
  background: rgb(216, 128, 238); // テナント主催の色
  cursor: pointer;

  .date {
    color: $base-brand-color;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 4px;
  }

  .result-badge {
    display: inline-block;
    background: $base-color-red;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    border-radius: 4px;
    padding: 2px 8px;
    margin-bottom: 4px;
  }

  .title {
    font-size: 16px;
    font-weight: bold;
    color: $base-color;
    line-height: 1.4;
  }

  .debug-phase-switch {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;

    button {
      border: 1px solid $base-brand-color;
      padding: 4px 10px;
      font-size: 11px;
      color: $base-brand-color;
      background: #fff;
    }
  }
}

.match-body {
  margin-top: 12px;

  .image {
    margin-bottom: 12px;
    cursor: pointer;

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  .entry {
    text-align: center;

    .entry-button {
      width: 100%;
      max-width: 280px;
      border-radius: 24px;
      padding: 10px 20px;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      background: $base-color-red;
      border: 1px solid $base-color-red;

      &.entered {
        color: $base-color-red;
        background: #fff;
        cursor: default;
      }
    }

    .wait-message {
      margin: 8px 0 0;
      font-size: 12px;
      color: $base-color;
    }

    .cancel {
      margin-top: 8px;

      .cancel-button {
        font-size: 12px;
        color: $gray-color;

        &::after {
          content: ' >';
        }
      }
    }
  }

  .faction-guide {
    margin: 0 0 12px;
    font-size: 13px;
    font-weight: bold;
    color: $base-color;
    text-align: center;
  }

  .faction-select {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 4px;
  }

  .faction-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .faction-button {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 40px;
    padding: 8px 16px;
    border-radius: 24px;
    border: 2px solid;
    background: #fff;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;

    &:disabled {
      cursor: default;
    }

    &.selected {
      .check-icon {
        width: 14px;
        height: 14px;
      }
    }
  }

  .faction-count {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-width: 72px;
    font-size: 12px;
    color: $base-color;
    white-space: nowrap;

    .user-icon {
      width: 14px;
      height: 14px;
    }
  }

  .faction-progress {
    .faction-stat {
      margin-bottom: 14px;

      .faction-meta {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 4px;

        .name {
          font-size: 13px;
          font-weight: bold;
        }
      }

      .mine-badge {
        display: inline-block;
        font-size: 11px;
        font-weight: bold;
        border-radius: 4px;
        padding: 2px 8px;
        margin-bottom: 4px;
      }

      .bar-wrap {
        position: relative;
      }

      .bar-track {
        position: relative;
        height: 28px;
        border-radius: 4px;
        overflow: hidden;
      }

      .bar-fill {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        border-radius: 4px;
        transition: width 0.3s ease;
      }

      .bar-steps {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        font-weight: bold;
        color: #fff;
        text-shadow: 0 0 2px rgba(0, 0, 0, 0.25);
        z-index: 1;
      }

      .win-badge {
        position: absolute;
        top: 50%;
        right: 8px;
        transform: translateY(-50%);
        display: inline-flex;
        align-items: center;
        gap: 4px;
        background: #fff;
        border: 1px solid #e6b422;
        border-radius: 20px;
        padding: 2px 8px 2px 4px;
        font-size: 11px;
        font-weight: bold;
        color: #c49200;
        z-index: 2;

        .crown {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: #f5d76e;

          svg {
            width: 12px;
            height: 12px;
          }
        }
      }
    }

    .company-rank {
      margin-top: 10px;
      text-align: center;
      font-size: 13px;
      font-weight: bold;
      color: $base-brand-color;
      cursor: pointer;

      &::after {
        content: ' >';
      }
    }
  }

  .stats {
    display: flex;
    background: #eef4fb;
    border-radius: 4px;
    padding: 12px 8px;

    .stat {
      flex: 1;
      text-align: center;

      &:first-child {
        border-right: 1px solid #c5d4e8;
      }

      .label {
        font-size: 12px;
        color: $base-color;
        margin-bottom: 4px;
      }

      .value {
        font-size: 16px;
        font-weight: bold;
        color: $base-brand-color;
      }
    }
  }

  .calculating {
    background: #eef4fb;
    border-radius: 4px;
    padding: 12px;
    text-align: center;

    .label {
      font-size: 12px;
      color: $base-color;
      margin-bottom: 4px;
    }

    .value {
      font-size: 16px;
      font-weight: bold;
      color: $base-color;
    }
  }
}

.match.isGeneral {
  border-color: #00f; // 運用主

  .match-header {
    background: #ccf;
  }
}
</style>
